import { ChevronDownIcon } from '@chakra-ui/icons';

import { Button, Flex, Menu, MenuButton, MenuDivider, MenuItem, MenuList, Skeleton } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ChakraFeatherIcon } from 'src/components/ChakraFeatherIcon';
import AvatarDefault from 'src/assets/images/avata-default.png';
import { useAuthContext } from '@/contexts/AuthContext';
import { useGetDashboardUserByIdQuery } from '@/services/queries/dashboard-user';
import { useTranslation } from 'react-i18next';

export const ProfileMenu = () => {
  const { t } = useTranslation();

  const { authenticationInfo } = useAuthContext();
  const { data, isLoading } = useGetDashboardUserByIdQuery(authenticationInfo?.uuid as string);
  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon color='neutral.700' w={4} />}
        variant='ghost'
        height='auto'
        colorScheme='neutral'
      >
        <Flex align='center' gap='deka'>
          <Flex gap='16px' align='center'>
            <img className='rounded-circle header-profile-user' src={data?.avatar_url || AvatarDefault} alt='Header Avatar' />
          </Flex>
          <span className='ms-2 d-none d-sm-block user-item-desc'>
            <span className='user-name'>
              {isLoading ? <Skeleton h='kilo' width='8rem' /> : `${data?.name}`.toLocaleUpperCase()}
            </span>
          </span>
        </Flex>
      </MenuButton>
      <MenuList>
        <MenuItem icon={<ChakraFeatherIcon name='file-text' />} as={Link} to={'/profile'}>
          {t('components.profile_menu.profile_menu_my_data')}
        </MenuItem>
        <MenuDivider />
        <MenuItem icon={<ChakraFeatherIcon name='log-out' />} as={Link} to={'/logout'}>
          {t('components.profile_menu.profile_menu_logout')}
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
